var _toConsumableArray = require("/workspace/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");
var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/workspace/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _objectWithoutProperties = require("/workspace/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/workspace/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/workspace/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/workspace/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
var _excluded = ["url"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e13) { throw _e13; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e14) { didErr = true; err = _e14; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require("core-js/modules/es.object.from-entries.js");
require("core-js/modules/es.promise.finally.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports.Primer = r() : e.Primer = r();
}(this, function () {
  return function () {
    "use strict";

    var _r$t;
    var e;
    var r,
      t,
      A,
      o,
      E,
      n,
      _,
      i,
      a,
      s,
      c,
      T,
      N,
      R = {};
    R.d = function (e, r) {
      for (var t in r) R.o(r, t) && !R.o(e, t) && Object.defineProperty(e, t, {
        enumerable: !0,
        get: r[t]
      });
    }, R.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, R.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var O = {};
    R.r(O), R.d(O, {
      SuccessScreenType: function SuccessScreenType() {
        return rr;
      },
      PaymentFlow: function PaymentFlow() {
        return e6;
      },
      PrimerClientError: function PrimerClientError() {
        return re;
      },
      ThreeDSecureStatus: function ThreeDSecureStatus() {
        return e5;
      },
      TokenType: function TokenType() {
        return e8;
      },
      isStripeOptionsDropInWithFullMandateText: function isStripeOptionsDropInWithFullMandateText() {
        return rt;
      },
      PaymentInstrumentType: function PaymentInstrumentType() {
        return e3;
      },
      ErrorCode: function ErrorCode() {
        return e9;
      },
      EventTypes: function EventTypes() {
        return rA;
      },
      CheckoutUXFlow: function CheckoutUXFlow() {
        return e2;
      },
      HeadlessManagerType: function HeadlessManagerType() {
        return ro;
      },
      PaymentMethodType: function PaymentMethodType() {
        return e4;
      },
      Primer: function Primer() {
        return rE;
      }
    });
    var P = {
        LEGACY: "legacy",
        V_2_4: "2.4"
      },
      d = P.V_2_4,
      D = d;
    var I = /*#__PURE__*/function (_Error) {
      _inherits(I, _Error);
      var _super = _createSuper(I);
      function I(e) {
        var _this;
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        _classCallCheck(this, I);
        var t, A;
        _this = _super.call(this, e), A = void 0, (t = "isReported") in _assertThisInitialized(_this) ? Object.defineProperty(_assertThisInitialized(_this), t, {
          value: A,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : _this[t] = A, _this.isReported = r, _this.name = _this.constructor.name, Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
        return _this;
      }
      _createClass(I, [{
        key: "markAsReported",
        value: function markAsReported() {
          this.isReported = !0;
        }
      }], [{
        key: "from",
        value: function from(e) {
          var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (e instanceof I) return e;
          var t = new I(e instanceof Error ? e.message : String(e), r);
          return e instanceof Error && e.stack && (t.stack = e.stack, Object.assign(t, e)), t;
        }
      }]);
      return I;
    }( /*#__PURE__*/_wrapNativeSuper(Error));
    var l = "https://analytics.production.data.primer.io/sdk-logs";
    var u = ((L = {}).REQUEST_START = "REQUEST_START", L.REQUEST_END = "REQUEST_END", L),
      S = ((m = {}).START = "START", m.END = "END", m);
    var C = {
      createHeadless: "HEADLESS_LOADING",
      showUniversalCheckout: "DROP_IN_LOADING",
      showVaultManager: "VAULT_MANAGER_LOADING",
      preloadPrimer: "PRELOAD_PRIMER_LOADING"
    };
    var L,
      m,
      Y,
      p,
      h = ((Y = {}).NETWORK_CALL_EVENT = "NETWORK_CALL_EVENT", Y.CRASH_EVENT = "CRASH_EVENT", Y.TIMER_EVENT = "TIMER_EVENT", Y.MESSAGE_EVENT = "MESSAGE_EVENT", Y.V1_EVENT = "V1_EVENT", Y.SDK_FUNCTION_EVENT = "SDK_FUNCTION_EVENT", Y),
      M = ((p = M || {}).CHARGING = "CHARGING", p.NOT_CHARGING = "NOT_CHARGING", p);
    function f() {
      return _f.apply(this, arguments);
    }
    function _f() {
      _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _navigator$getBattery, _navigator, _performance$memory, _screen, _screen2;
        var e;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!("undefined" == typeof navigator || "undefined" == typeof performance)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _context6.next = 4;
              return (_navigator$getBattery = (_navigator = navigator).getBattery) === null || _navigator$getBattery === void 0 ? void 0 : _navigator$getBattery.call(_navigator);
            case 4:
              e = _context6.sent;
              return _context6.abrupt("return", {
                memoryFootprint: (_performance$memory = performance.memory) === null || _performance$memory === void 0 ? void 0 : _performance$memory.usedJSHeapSize,
                screen: {
                  height: (_screen = screen) === null || _screen === void 0 ? void 0 : _screen.height,
                  width: (_screen2 = screen) === null || _screen2 === void 0 ? void 0 : _screen2.width
                },
                userAgent: navigator.userAgent,
                locale: navigator.language,
                batteryLevel: e === null || e === void 0 ? void 0 : e.level,
                batteryStatus: e !== null && e !== void 0 && e.charging ? "CHARGING" : "NOT_CHARGING"
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _f.apply(this, arguments);
    }
    var y = {
      get: function get(e, r) {
        var t;
        try {
          switch (e) {
            case "PRIMER_SDK_VERSION":
              t = "v2.54.0";
              break;
            case "PRIMER_ASSETS_URL":
              t = process.env.PRIMER_ASSETS_URL;
              break;
            case "PRIMER_BUILD_INTEGRATION_BUILDER":
              t = process.env.PRIMER_BUILD_INTEGRATION_BUILDER;
          }
        } catch (_unused) {}
        return t || r;
      }
    }.get("PRIMER_SDK_VERSION");
    function U(_x, _x2, _x3) {
      return _U.apply(this, arguments);
    }
    function _U() {
      _U = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, r, t) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = _objectSpread;
              _context7.t1 = _objectSpread({}, t);
              _context7.t2 = {};
              _context7.t3 = Date.now();
              _context7.next = 6;
              return f();
            case 6:
              _context7.t4 = _context7.sent;
              _context7.t5 = e;
              _context7.t6 = r;
              _context7.t7 = y;
              _context7.t8 = {
                createdAt: _context7.t3,
                device: _context7.t4,
                eventType: _context7.t5,
                properties: _context7.t6,
                sdkVersion: _context7.t7,
                sdkType: "WEB"
              };
              return _context7.abrupt("return", (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t8));
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _U.apply(this, arguments);
    }
    var k = Symbol.for("__primerAnalytics__"),
      w = {
        providers: new Map(),
        timers: new Map(),
        eventsQueue: new Map()
      };
    if ("undefined" != typeof window) {
      var _e = window[k];
      _e ? w = _e : window[k] = w;
    }
    var g = function g() {
        return w.providers;
      },
      B = function B() {
        return w.timers;
      },
      v = function v() {
        return w.eventsQueue;
      },
      H = new Map();
    function G(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      H.has(e) && (clearTimeout(H.get(e)), H.delete(e));
      var A = function A() {
        var A = v().get(e);
        if (A !== null && A !== void 0 && A.length) {
          var _o = !0,
            _E = [],
            _n = 0,
            _2 = 0;
          for (; _2 < A.length;) {
            var _r = A[_2],
              _t = new Blob([JSON.stringify(_r)]).size;
            if (_t > 64e3) {
              console.error("Event size exceeds maximum payload size and will be skipped:", _r), _2++;
              continue;
            }
            if (_n + _t > 64e3 && _E.length > 0) {
              try {
                _o = navigator.sendBeacon(e, JSON.stringify(_E));
              } catch (e) {
                _o = !1, console.error("Unable to send events", e);
              }
              if (!_o) break;
              _E = [], _n = 0;
            }
            _E.push(_r), _n += _t, _2++;
          }
          if (_E.length > 0 && _o) try {
            _o = navigator.sendBeacon(e, JSON.stringify(_E));
          } catch (e) {
            _o = !1, console.error("Unable to send events", e);
          }
          _o ? v().delete(e) : t < 5 ? setTimeout(function () {
            return G(e, r, t + 1);
          }, 500 * Math.pow(2, t)) : console.error("Max retry attempts reached. Events will not be sent.");
        }
      };
      if (r) return void A();
      var o = setTimeout(A, 500);
      H.set(e, o);
    }
    var F = !1;
    function b(_ref) {
      var _ref$url = _ref.url,
        e = _ref$url === void 0 ? l : _ref$url,
        r = _objectWithoutProperties(_ref, _excluded);
      "undefined" == typeof document || F || (document.addEventListener("visibilitychange", function () {
        if ("hidden" === document.visibilityState) {
          var _e2 = K(r.checkoutSessionId);
          _e2.messageEvent({
            messageType: "VISIBILITY_CHANGE",
            message: "Checkout visibility is hidden (tab or window change, redirect or being closed)."
          }), G(_e2.url, !0);
        }
      }), F = !0);
      var t = function t(_t2) {
          return /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(A) {
              var _E2;
              var o, E;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = "undefined" != typeof navigator;
                    if (!_context.t0) {
                      _context.next = 12;
                      break;
                    }
                    _context.t1 = function e(r, t) {
                      var A = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();
                      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                      var E = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
                      if (o > E || A.has(r)) return r;
                      A.add(r);
                      var n = function n(r) {
                        return "object" == typeof r && null !== r ? e(r, t, A, o + 1, E) : t(r);
                      };
                      return Array.isArray(r) ? r.map(n) : Object.fromEntries(Object.entries(r).map(function (_ref3) {
                        var _ref4 = _slicedToArray(_ref3, 2),
                          e = _ref4[0],
                          r = _ref4[1];
                        return [e, n(r)];
                      }));
                    };
                    _context.next = 5;
                    return U(_t2, A, r);
                  case 5:
                    _context.t2 = _context.sent;
                    _context.t3 = function (e) {
                      var r;
                      return "string" == typeof (r = "function" == typeof e ? e.name || "function" : e) && r.length > 5120 ? "".concat(r.slice(0, 5120), "...") : r;
                    };
                    o = (0, _context.t1)(_context.t2, _context.t3);
                    v().has(e) || v().set(e, []);
                    E = v().get(e);
                    (_E2 = E) !== null && _E2 !== void 0 && _E2.push(o);
                    G(e);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x4) {
              return _ref2.apply(this, arguments);
            };
          }();
        },
        A = {
          crashEvent: t(h.CRASH_EVENT),
          messageEvent: t(h.MESSAGE_EVENT),
          networkCallEvent: t(h.NETWORK_CALL_EVENT),
          sdkFunctionEvent: t(h.SDK_FUNCTION_EVENT),
          timerStart: function timerStart(_ref5) {
            var _performance;
            var e = _ref5.id,
              A = _objectWithoutProperties(_ref5, _excluded2);
            var o = "".concat(r.checkoutSessionId, "|").concat(e),
              E = (_performance = performance) !== null && _performance !== void 0 && _performance.now ? performance.now() : Date.now();
            return B().set(o, {
              start: E
            }), t(h.TIMER_EVENT)(_objectSpread(_objectSpread({}, A), {}, {
              id: e,
              timerType: S.START
            }));
          },
          timerEnd: function timerEnd(_ref6) {
            var _B$get, _performance2;
            var e = _ref6.id,
              A = _objectWithoutProperties(_ref6, _excluded3);
            var o = "".concat(r.checkoutSessionId, "|").concat(e),
              _ref7 = (_B$get = B().get(o)) !== null && _B$get !== void 0 ? _B$get : {},
              E = _ref7.start;
            B().delete(o);
            var n = (_performance2 = performance) !== null && _performance2 !== void 0 && _performance2.now ? performance.now() : Date.now();
            return t(h.TIMER_EVENT)(_objectSpread(_objectSpread({}, A), {}, {
              id: e,
              timerType: S.END,
              duration: E ? n - E : void 0
            }));
          },
          v1Event: t(h.V1_EVENT),
          url: e
        };
      return g().set(r.checkoutSessionId, A), K(r.checkoutSessionId);
    }
    function K(e) {
      return new Proxy({}, {
        get: function get(r, t) {
          var _g$get;
          return ((_g$get = g().get(e)) !== null && _g$get !== void 0 ? _g$get : b({
            checkoutSessionId: e
          }))[t];
        }
      });
    }
    var V = function V(e, r, t, A) {
      return {
        callType: t ? u.REQUEST_END : u.REQUEST_START,
        id: e,
        errorBody: (t === null || t === void 0 ? void 0 : t.error) && JSON.stringify(t.error, Object.getOwnPropertyNames(t.error)),
        method: r.method,
        responseCode: t === null || t === void 0 ? void 0 : t.status,
        url: r.url,
        duration: A
      };
    };
    function x(e) {
      return e ? new Promise(function (r) {
        setTimeout(r, e);
      }) : Promise.resolve();
    }
    function W(_x5, _x6, _x7) {
      return _W.apply(this, arguments);
    }
    function _W() {
      _W = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, r, t) {
        var _r$enabled;
        var A,
          o,
          E,
          _r9,
          _e9,
          _e10,
          _r10,
          _n4,
          _A4,
          _4,
          _i,
          _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              A = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : x;
              o = 0, E = {
                enabled: (_r$enabled = r === null || r === void 0 ? void 0 : r.enabled) !== null && _r$enabled !== void 0 ? _r$enabled : !1,
                maxRetries: 8,
                initialBackoff: 100,
                retryNetworkErrors: !0,
                retry500Errors: !1,
                maxJitter: 100
              };
              if (E.enabled) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("return", e());
            case 4:
              _context8.prev = 4;
              _context8.next = 7;
              return e();
            case 7:
              _r9 = _context8.sent;
              if (o) {
                _e9 = "Request succeeded after ".concat(o, " retries.");
                "object" == typeof _r9 && _r9 && "status" in _r9 && (_e9 += " Status code: ".concat(_r9.status)), t === null || t === void 0 ? void 0 : t({
                  messageType: "RETRY_SUCCESS",
                  message: _e9,
                  severity: "INFO"
                });
              }
              return _context8.abrupt("return", _r9);
            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](4);
              _e10 = o >= E.maxRetries, _r10 = _context8.t0.isNetworkError && !E.retryNetworkErrors, _n4 = _context8.t0.status && _context8.t0.status >= 500 && !E.retry500Errors;
              if (!(_e10 || _r10 || _n4)) {
                _context8.next = 18;
                break;
              }
              _A4 = "Failed after ".concat(o, " retries. ");
              throw _e10 ? _A4 += "Reached maximum retries (".concat(E.maxRetries, ").") : _r10 ? _A4 += "Network error encountered and retryNetworkErrors is disabled." : _n4 && (_A4 += "HTTP 500 error encountered and retry500Errors is disabled."), _A4 += " Last error: ".concat(_context8.t0.message), t !== null && t !== void 0 && t({
                messageType: "RETRY_FAILED",
                message: _A4,
                severity: "ERROR",
                errorBody: JSON.stringify(_context8.t0, Object.getOwnPropertyNames(_context8.t0))
              }), Error(_A4, {
                cause: _context8.t0
              });
            case 18:
              o++;
              _4 = Math.min(E.initialBackoff * Math.pow(2, o - 1) + Math.random() * E.maxJitter, Number.MAX_SAFE_INTEGER), _i = "Unknown error";
              _context8.t0.isNetworkError ? _i = "Network error" : _context8.t0.status && (_i = "HTTP ".concat(_context8.t0.status, " error"));
              t !== null && t !== void 0 && t({
                messageType: "RETRY",
                message: "Retry attempt ".concat(o, "/").concat(E.maxRetries, " due to: ").concat(_i, ". Error details: ").concat(_context8.t0.message, ". Waiting for ").concat(_4.toFixed(2), "ms before next attempt."),
                severity: "WARN",
                errorBody: JSON.stringify(_context8.t0, Object.getOwnPropertyNames(_context8.t0))
              });
              _context8.next = 24;
              return A(_4);
            case 24:
              _context8.next = 4;
              break;
            case 26:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[4, 12]]);
      }));
      return _W.apply(this, arguments);
    }
    var $ = {
      cache: new Map()
    };
    "undefined" != typeof window && ((_r$t = (r = window)[t = "__primerCache__"]) !== null && _r$t !== void 0 ? _r$t : r[t] = $, $ = window.__primerCache__);
    var j = function j() {
      return $.cache;
    };
    function X() {
      if (j().size <= 30) return;
      var e = Date.now();
      var _iterator = _createForOfIteratorHelper(j()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            _r2 = _step$value[0],
            _t3 = _step$value[1];
          _t3.exp < e && j().delete(_r2);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (j().size > 50) {
        var _iterator2 = _createForOfIteratorHelper(j()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 1),
              _e3 = _step2$value[0];
            if (j().size <= 50) break;
            j().delete(_e3);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    var z = function z() {
        var _J$randomUUID;
        return ((_J$randomUUID = J.randomUUID) === null || _J$randomUUID === void 0 ? void 0 : _J$randomUUID.call(J)) || Q();
      },
      Q = function Q() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (e) {
          return (e ^ Z() >> e / 4).toString(16);
        });
      },
      Z = function Z() {
        var _J$getRandomValues$, _J$getRandomValues;
        return ((_J$getRandomValues$ = (_J$getRandomValues = J.getRandomValues) === null || _J$getRandomValues === void 0 ? void 0 : _J$getRandomValues.call(J, new Uint8Array(1))[0]) !== null && _J$getRandomValues$ !== void 0 ? _J$getRandomValues$ : 16 * Math.random()) & 15;
      },
      J = "undefined" != typeof crypto ? crypto : {},
      q = function q(e, r, t) {
        return ee(e, "get", r, t);
      },
      ee = /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r, t, A, o) {
          var _performance3;
          var E, n, _, i, _performance4, _a, _e4, _s, _r3, _s$clientSession, _t4, _A, _c, _performance5, _e5;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                E = z(), n = (_performance3 = performance) === null || _performance3 === void 0 ? void 0 : _performance3.now(), _ = K(e), i = {
                  method: r,
                  url: t,
                  body: o
                };
                _.networkCallEvent(V(E, i));
                _context2.prev = 2;
                _context2.next = 5;
                return fetch(t, {
                  body: o,
                  method: r,
                  headers: _objectSpread({
                    "content-type": "application/json",
                    "x-request-id": E
                  }, A)
                });
              case 5:
                _a = _context2.sent;
                if (_a.ok) {
                  _context2.next = 9;
                  break;
                }
                _e4 = Error("HTTP error! status: ".concat(_a.status));
                throw _e4.status = _a.status, _e4;
              case 9:
                _context2.next = 11;
                return _a.json();
              case 11:
                _s = _context2.sent;
                if (t.includes("client-sdk/configuration")) {
                  _r3 = _s.primerAccountId, _s$clientSession = _s.clientSession, _t4 = _s$clientSession.clientSessionId, _A = _s$clientSession.customer;
                  _ = b({
                    checkoutSessionId: e,
                    clientSessionId: _t4,
                    customerId: _A === null || _A === void 0 ? void 0 : _A.customerId,
                    primerAccountId: _r3,
                    url: _.url
                  });
                }
                _c = (_performance4 = performance) === null || _performance4 === void 0 ? void 0 : _performance4.now();
                return _context2.abrupt("return", (_.networkCallEvent(V(E, i, {
                  data: _s
                }, _c - n)), {
                  data: _s,
                  headers: _a.headers,
                  status: _a.status,
                  source: "NETWORK"
                }));
              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](2);
                _e5 = (_performance5 = performance) === null || _performance5 === void 0 ? void 0 : _performance5.now();
                throw Object.assign(_context2.t0, {
                  isNetworkError: _context2.t0 instanceof TypeError
                }), _.networkCallEvent(V(E, i, {
                  error: _context2.t0
                }, _e5 - n)), _context2.t0;
              case 21:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[2, 17]]);
        }));
        return function ee(_x8, _x9, _x10, _x11, _x12) {
          return _ref8.apply(this, arguments);
        };
      }(),
      er = function er(e, r) {
        return new Promise(function (t, A) {
          var o = setTimeout(function () {
            var e = Error("Request timed out");
            e.isNetworkError = !0, A(e);
          }, r);
          e.then(t).catch(A).finally(function () {
            return clearTimeout(o);
          });
        });
      },
      et = function et(e, r) {
        var t = r.headers,
          A = r.retryConfig,
          o = r.cacheConfig,
          _r$timeout = r.timeout,
          E = _r$timeout === void 0 ? 15e3 : _r$timeout,
          n = r.checkoutSessionId,
          _ = K(n);
        return function (e) {
          if (!e) return function (e) {
            return e();
          };
          var r = e.key,
            _e$refresh = e.refresh,
            t = _e$refresh === void 0 ? !1 : _e$refresh,
            _e$usePrimerSessionCa = e.usePrimerSessionCacheTtlHeader,
            A = _e$usePrimerSessionCa === void 0 ? !1 : _e$usePrimerSessionCa,
            _e$ttl = e.ttl,
            o = _e$ttl === void 0 ? 36e5 : _e$ttl;
          return /*#__PURE__*/function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
              var E, n, _;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    E = Date.now(), n = j().get(r);
                    if (!(!t && n && n.exp > E)) {
                      _context3.next = 3;
                      break;
                    }
                    return _context3.abrupt("return", n.promise);
                  case 3:
                    n && j().delete(r);
                    _ = e().then(function (e) {
                      var t = o;
                      return A && (t = 1e3 * (Number(e.headers.get("x-primer-session-cache-ttl")) || 0)), function (_ref10, t) {
                        var e = _ref10.key,
                          _ref10$ttl = _ref10.ttl,
                          r = _ref10$ttl === void 0 ? 36e5 : _ref10$ttl;
                        r ? j().set(e, {
                          promise: Promise.resolve(_objectSpread(_objectSpread({}, t), {}, {
                            source: "CACHE"
                          })),
                          exp: Date.now() + r
                        }) : j().delete(e);
                      }({
                        key: r,
                        ttl: t
                      }, e), X(), e;
                    }, function (e) {
                      throw j().delete(r), e;
                    });
                    return _context3.abrupt("return", (j().set(r, {
                      promise: _,
                      exp: E + o
                    }), X(), _));
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x13) {
              return _ref9.apply(this, arguments);
            };
          }();
        }(o)(function () {
          return W(function () {
            return er(q(n, e, t), E);
          }, A, function (r) {
            return _.messageEvent(_objectSpread(_objectSpread({}, r), {}, {
              url: e
            }));
          });
        });
      },
      eA = "function" == typeof Buffer,
      eo = "function" == typeof TextDecoder ? new TextDecoder() : void 0,
      eE = "function" == typeof TextEncoder ? new TextEncoder() : void 0,
      en = Array.prototype.slice.call("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="),
      e_ = function (e) {
        var r = {};
        return e.forEach(function (e, t) {
          return r[e] = t;
        }), r;
      }(en),
      ei = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/,
      ea = String.fromCharCode.bind(String),
      es = "function" == typeof Uint8Array.from ? Uint8Array.from.bind(Uint8Array) : function (e) {
        return new Uint8Array(Array.prototype.slice.call(e, 0));
      },
      ec = function ec(e) {
        return e.replace(/=/g, "").replace(/[+\/]/g, function (e) {
          return "+" == e ? "-" : "_";
        });
      },
      eT = function eT(e) {
        return e.replace(/[^A-Za-z0-9\+\/]/g, "");
      },
      eN = "function" == typeof btoa ? function (e) {
        return btoa(e);
      } : eA ? function (e) {
        return Buffer.from(e, "binary").toString("base64");
      } : function (e) {
        var r,
          t,
          A,
          o,
          E = "",
          n = e.length % 3;
        for (var _n2 = 0; _n2 < e.length;) {
          if ((t = e.charCodeAt(_n2++)) > 255 || (A = e.charCodeAt(_n2++)) > 255 || (o = e.charCodeAt(_n2++)) > 255) throw TypeError("invalid character found");
          E += en[(r = t << 16 | A << 8 | o) >> 18 & 63] + en[r >> 12 & 63] + en[r >> 6 & 63] + en[63 & r];
        }
        return n ? E.slice(0, n - 3) + "===".substring(n) : E;
      },
      eR = eA ? function (e) {
        return Buffer.from(e).toString("base64");
      } : function (e) {
        var r = [];
        for (var _t5 = 0, _A2 = e.length; _t5 < _A2; _t5 += 4096) r.push(ea.apply(null, e.subarray(_t5, _t5 + 4096)));
        return eN(r.join(""));
      },
      eO = function eO(e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return r ? ec(eR(e)) : eR(e);
      },
      eP = function eP(e) {
        if (e.length < 2) {
          var r = e.charCodeAt(0);
          return r < 128 ? e : r < 2048 ? ea(192 | r >>> 6) + ea(128 | 63 & r) : ea(224 | r >>> 12 & 15) + ea(128 | r >>> 6 & 63) + ea(128 | 63 & r);
        }
        var r = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
        return ea(240 | r >>> 18 & 7) + ea(128 | r >>> 12 & 63) + ea(128 | r >>> 6 & 63) + ea(128 | 63 & r);
      },
      ed = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
      eD = function eD(e) {
        return e.replace(ed, eP);
      },
      eI = eA ? function (e) {
        return Buffer.from(e, "utf8").toString("base64");
      } : eE ? function (e) {
        return eR(eE.encode(e));
      } : function (e) {
        return eN(eD(e));
      },
      el = function el(e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return r ? ec(eI(e)) : eI(e);
      },
      eu = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g,
      eS = function eS(e) {
        switch (e.length) {
          case 4:
            var r = ((7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3)) - 65536;
            return ea((r >>> 10) + 55296) + ea((1023 & r) + 56320);
          case 3:
            return ea((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
          default:
            return ea((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
        }
      },
      eC = function eC(e) {
        return e.replace(eu, eS);
      },
      eL = "function" == typeof atob ? function (e) {
        return atob(eT(e));
      } : eA ? function (e) {
        return Buffer.from(e, "base64").toString("binary");
      } : function (e) {
        if (e = e.replace(/\s+/g, ""), !ei.test(e)) throw TypeError("malformed base64.");
        e += "==".slice(2 - (3 & e.length));
        var r,
          t = "",
          A,
          o;
        for (var E = 0; E < e.length;) r = e_[e.charAt(E++)] << 18 | e_[e.charAt(E++)] << 12 | (A = e_[e.charAt(E++)]) << 6 | (o = e_[e.charAt(E++)]), t += 64 === A ? ea(r >> 16 & 255) : 64 === o ? ea(r >> 16 & 255, r >> 8 & 255) : ea(r >> 16 & 255, r >> 8 & 255, 255 & r);
        return t;
      },
      em = eA ? function (e) {
        return es(Buffer.from(e, "base64"));
      } : function (e) {
        return es(eL(e).split("").map(function (e) {
          return e.charCodeAt(0);
        }));
      },
      eY = function eY(e) {
        return em(eh(e));
      },
      ep = eA ? function (e) {
        return Buffer.from(e, "base64").toString("utf8");
      } : eo ? function (e) {
        return eo.decode(em(e));
      } : function (e) {
        return eC(eL(e));
      },
      eh = function eh(e) {
        return eT(e.replace(/[-_]/g, function (e) {
          return "-" == e ? "+" : "/";
        }));
      },
      eM = function eM(e) {
        return ep(eh(e));
      },
      ef = function ef(e) {
        return {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        };
      },
      ey = {
        encode: el,
        decode: eM
      },
      eU = {
        encode: function encode(e) {
          var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _r$urlSafe = r.urlSafe,
            t = _r$urlSafe === void 0 ? !1 : _r$urlSafe;
          return ey.encode(e, t);
        },
        decode: ey.decode
      },
      ek = "The provided `clientToken`",
      ew = "".concat(ek, " has expired"),
      eg = "".concat(ek, " is malformed"),
      eB = function eB(e, r, t) {
        return _objectSpread({
          "primer-client-token": e,
          "primer-sdk-client": "WEB",
          "primer-sdk-version": "v2.54.0",
          "primer-sdk-checkout-session-id": r
        }, t && {
          "x-api-version": t
        });
      };
    function ev(_x14, _x15, _x16) {
      return _ev.apply(this, arguments);
    }
    function _ev() {
      _ev = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, r, t) {
        var _ref15, A, o, E, n, _, i, _yield$et, _e11, _E3, _e12;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _ref15 = function (e) {
                var r = function (e) {
                    try {
                      var _e$split = e.split("."),
                        _e$split2 = _slicedToArray(_e$split, 2),
                        _r11 = _e$split2[0],
                        _t7 = _e$split2[1];
                      return JSON.parse(eU.decode(_t7 || _r11));
                    } catch (_unused3) {
                      throw Error(eg);
                    }
                  }(e),
                  t = 1e3 * r.exp;
                if (Date.now() > t) throw Error("".concat(ew, ". Expiration date: ").concat(new Date(t).toISOString()));
                return r;
              }(e), A = _ref15.accessToken, o = _ref15.configurationUrl, E = _ref15.analyticsUrlV2, n = b({
                checkoutSessionId: r,
                url: E
              }), _ = D, i = _ !== P.LEGACY ? _ : "2.3";
              n.timerStart({
                id: "CONFIGURATION_LOADING"
              });
              _context9.prev = 2;
              _context9.next = 5;
              return et("".concat(o, "/?withDisplayMetadata=true"), {
                checkoutSessionId: r,
                headers: eB(A, r, i),
                retryConfig: {
                  enabled: !0
                },
                cacheConfig: t
              });
            case 5:
              _yield$et = _context9.sent;
              _e11 = _yield$et.data;
              _E3 = _yield$et.source;
              return _context9.abrupt("return", (n.timerEnd({
                id: "CONFIGURATION_LOADING",
                context: {
                  source: _E3
                }
              }), _e11));
            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](2);
              _e12 = _context9.t0 instanceof Error ? _context9.t0.message : "Unknown error occurred";
              throw Error("Failed to initialize client: ".concat(_e12));
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[2, 11]]);
      }));
      return _ev.apply(this, arguments);
    }
    function eH(e) {
      return e instanceof Error ? {
        errorBody: e.message,
        stacktrace: e.stack
      } : "object" == typeof e && null !== e && "message" in e ? {
        errorBody: String(e.message),
        stacktrace: "stack" in e ? String(e.stack) : void 0
      } : {
        errorBody: String(e || "Unknown error")
      };
    }
    function eG(_ref11) {
      var e = _ref11.checkoutSessionId,
        r = _ref11.analytics,
        t = _ref11.error,
        A = _ref11.reporter;
      r !== null && r !== void 0 && r.crashEvent ? r.crashEvent(_objectSpread(_objectSpread({}, eH(t)), {}, {
        reporter: A
      })) : e && eF(e, t, A);
    }
    function eF(_x17, _x18, _x19) {
      return _eF.apply(this, arguments);
    }
    function _eF() {
      _eF = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e, r, t) {
        var A;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return U(h.CRASH_EVENT, _objectSpread(_objectSpread({}, eH(r)), {}, {
                reporter: t
              }), {
                checkoutSessionId: e
              });
            case 2:
              A = _context10.sent;
              _context10.prev = 3;
              _context10.next = 6;
              return fetch(l, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(A)
              });
            case 6:
              _context10.next = 11;
              break;
            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](3);
              console.error("Failed to post crash event", _context10.t0);
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[3, 8]]);
      }));
      return _eF.apply(this, arguments);
    }
    var eb = Symbol.for("initGlobalErrorMonitoringLoaded"),
      eK = function eK(e, r) {
        "undefined" != typeof window && window[eb] || (window[eb] = !0, window.addEventListener("error", function (t) {
          !eV(t) && ex(t) && eG({
            checkoutSessionId: e,
            analytics: r,
            error: t.error,
            reporter: "window.onerror"
          });
        }), window.addEventListener("unhandledrejection", function (t) {
          var A = t.reason || Error("Unhandled promise rejection");
          eW(A) && eG({
            checkoutSessionId: e,
            analytics: r,
            error: A,
            reporter: "unhandledrejection"
          });
        }));
      },
      eV = function eV(e) {
        return "Script error." === e.message || !e.filename || 0 === e.lineno;
      },
      ex = function ex(e) {
        var r = e.filename;
        return !!(r && e$(r)) && !!new I(e.error).isReported;
      },
      eW = function eW(e) {
        if (e && "object" == typeof e && "stack" in e && "string" == typeof e.stack) {
          var _r4 = I.from(e);
          return !_r4.isReported && (!!("fileName" in e && "string" == typeof e.fileName && e$(e.fileName)) || ej(_r4.stack).some(e$));
        }
        return !1;
      },
      e$ = function e$(e) {
        try {
          return new URL(e, window.location.origin).hostname.endsWith(".primer.io");
        } catch (_unused2) {
          return !1;
        }
      },
      ej = function ej(e) {
        if (!e) return [];
        var r = e.split("\n"),
          t = [],
          A = /^\s*at\s+(?:.*?\s+)?\(?(.+?):\d+:\d+\)?$/;
        var _iterator3 = _createForOfIteratorHelper(r),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e6 = _step3.value;
            var _r5 = _e6.match(A);
            if (_r5 && _r5[1]) t.push(_r5[1]);else {
              var _r6 = /@(.*?):\d+:\d+$/,
                _A3 = _e6.match(_r6);
              _A3 && _A3[1] && t.push(_A3[1]);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return t;
      };
    function eX(e, r, t) {
      return document.querySelector("".concat(e, "[").concat(r, "^=\"").concat(t, "\"]"));
    }
    function ez(_x20, _x21, _x22, _x23, _x24, _x25) {
      return _ez.apply(this, arguments);
    }
    function _ez() {
      _ez = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e, r, t, A, o, E) {
        var n, _E$name, _, i;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              n = E.analytics, _E$name = E.name, _ = _E$name === void 0 ? r : _E$name, i = E.retryConfig;
              _context11.next = 3;
              return W(function () {
                return new Promise(function (E, i) {
                  var a;
                  var s,
                    c = eX(e, t, r) || (a = _objectSpread(_objectSpread({}, A), {}, _defineProperty({}, t, r)), s = document.createElement(e), Object.entries(a).forEach(function (_ref16) {
                      var _ref17 = _slicedToArray(_ref16, 2),
                        e = _ref17[0],
                        r = _ref17[1];
                      return s.setAttribute(e, r);
                    }), s);
                  c.onload = function () {
                    n !== null && n !== void 0 && n.sdkFunctionEvent({
                      name: _,
                      params: ["".concat(e.charAt(0).toUpperCase() + e.slice(1), " loaded successfully: ").concat(r)]
                    }), E();
                  }, c.onerror = function () {
                    c.remove(), i(Error("".concat(o, ": ").concat(r)));
                  }, c.parentNode || document.head.appendChild(c);
                });
              }, i, function (e) {
                return n === null || n === void 0 ? void 0 : n.messageEvent(_objectSpread(_objectSpread({}, e), {}, {
                  url: r
                }));
              });
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return _ez.apply(this, arguments);
    }
    function eQ(_x26) {
      return _eQ.apply(this, arguments);
    }
    function _eQ() {
      _eQ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(r) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", e || (e = Promise.all([function (e) {
                var _r$analytics, _r$name;
                var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return eX("script", "src", e) && window.__Primer ? ((_r$analytics = r.analytics) !== null && _r$analytics !== void 0 && _r$analytics.sdkFunctionEvent({
                  name: (_r$name = r.name) !== null && _r$name !== void 0 ? _r$name : e,
                  params: ["Script already loaded"]
                }), Promise.resolve()) : ez("script", e, "src", _objectSpread(_objectSpread({}, r.attributes), {}, {
                  async: "",
                  crossorigin: "anonymous"
                }), "Can't load Primer SDK", r);
              }("https://sdk.primer.io/web/v2.54.0/PrimerCoreSDK.min.js", {
                analytics: r,
                name: "loadPrimerScript"
              }), function (e) {
                var _r$analytics2, _r$name2;
                var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return Array.from(document.styleSheets).some(function (r) {
                  return r.href === e;
                }) ? ((_r$analytics2 = r.analytics) !== null && _r$analytics2 !== void 0 && _r$analytics2.sdkFunctionEvent({
                  name: (_r$name2 = r.name) !== null && _r$name2 !== void 0 ? _r$name2 : e,
                  params: ["Stylesheet already loaded"]
                }), Promise.resolve()) : ez("link", e, "href", _objectSpread(_objectSpread({}, r.attributes), {}, {
                  rel: "stylesheet"
                }), "Can't load Primer SDK's Stylesheet", r);
              }("https://sdk.primer.io/web/v2.54.0/Checkout.css", {
                analytics: r,
                name: "loadPrimerCss"
              })]).then(function () {
                var e = window.__Primer;
                return delete window.__Primer, e;
              }).catch(function (r) {
                throw e = void 0, r;
              })));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return _eQ.apply(this, arguments);
    }
    var eZ = /*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var e, _r7, _t6, _r8;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                e = z();
                _context4.prev = 1;
                _r7 = K(e);
                _context4.prev = 3;
                eK(e, _r7);
                _r7.sdkFunctionEvent({
                  name: "preloadPrimer"
                });
                _r7.timerStart({
                  id: C.preloadPrimer
                });
                _context4.next = 9;
                return eQ(_r7);
              case 9:
                _r7.timerEnd({
                  id: C.preloadPrimer
                });
                _context4.next = 16;
                break;
              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](3);
                _t6 = I.from(_context4.t0);
                throw _t6.isReported || (eG({
                  checkoutSessionId: e,
                  analytics: _r7,
                  error: _t6,
                  reporter: "preloadPrimer level 1"
                }), _t6.markAsReported()), _t6;
              case 16:
                _context4.next = 22;
                break;
              case 18:
                _context4.prev = 18;
                _context4.t1 = _context4["catch"](1);
                _r8 = I.from(_context4.t1);
                throw _r8.isReported || (eF(e, _r8, "preloadPrimer level 0"), _r8.markAsReported()), _r8;
              case 22:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[1, 18], [3, 12]]);
        }));
        return function eZ() {
          return _ref12.apply(this, arguments);
        };
      }(),
      eJ = e1("createHeadless"),
      eq = e1("showUniversalCheckout"),
      e0 = e1("showVaultManager");
    function e1(e) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _o2;
        var _len,
          _ref13,
          _key,
          r,
          t,
          A,
          o,
          E,
          _o3,
          _yield$Promise$all,
          _yield$Promise$all2,
          _n3,
          _3,
          _e7,
          _e8,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              for (_len = _args5.length, _ref13 = new Array(_len), _key = 0; _key < _len; _key++) {
                _ref13[_key] = _args5[_key];
              }
              r = _ref13[0], t = _ref13[1], A = _ref13.slice(2);
              (o = t === null || t === void 0 ? void 0 : t.apiVersion) || console.warn("[Primer SDK] No API version was explicitly set. Defaulting to '".concat(d, "'.")), D = (_o2 = o) !== null && _o2 !== void 0 ? _o2 : d;
              E = z();
              _context5.prev = 4;
              _o3 = K(E);
              _context5.prev = 6;
              eK(E, _o3), _o3.sdkFunctionEvent({
                name: e,
                params: [r, t].concat(_toConsumableArray(A))
              }), _o3.timerStart({
                id: C[e]
              });
              _context5.next = 10;
              return Promise.all([ev(r, E, t !== null && t !== void 0 && t.clientSessionCachingEnabled ? {
                key: r,
                usePrimerSessionCacheTtlHeader: !0
              } : void 0), eQ(_o3)]);
            case 10:
              _yield$Promise$all = _context5.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              _n3 = _yield$Promise$all2[0];
              _3 = _yield$Promise$all2[1];
              return _context5.abrupt("return", _3[e].apply(_3, [_n3, E, r, t].concat(_toConsumableArray(A))));
            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](6);
              _e7 = I.from(_context5.t0);
              throw _e7.isReported || (eG({
                checkoutSessionId: E,
                analytics: _o3,
                error: _e7,
                reporter: "lazyLoad level 1"
              }), _e7.markAsReported()), _e7;
            case 21:
              _context5.next = 27;
              break;
            case 23:
              _context5.prev = 23;
              _context5.t1 = _context5["catch"](4);
              _e8 = I.from(_context5.t1);
              throw _e8.isReported || (eF(E, _e8, "lazyLoad level 0"), _e8.markAsReported()), _e8;
            case 27:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[4, 23], [6, 17]]);
      }));
    }
    (A = {}).LOADING = "Loading", A.NO_PAYMENT_METHOD = "NoPaymentMethod", A.THREE_DS = "UniversalCheckout/3ds", A.CHOOSE_PAYMENT_METHOD = "UniversalCheckout/Home", A.MANAGE_PAYMENT_METHODS = "VaultManager/Home", A.DIRECT_DEBIT_FORM = "DirectDebit/Form", A.DIRECT_DEBIT_MANDATE = "DirectDebit/Mandate", A.CREDIT_CARD_FORM = "CreditCard/Form", A.SUCCESS_PAYMENT_METHOD = "UniversalCheckout/Success/PaymentMethod", A.SUCCESS_CHECK = "UniversalCheckout/Success/Check", (o = {}).ROOT = "primer-checkout", o.ROOT_CONTENT = "primer-checkout-content", o.SUBMIT_BUTTON = "primer-checkout-submit-button", o.THREE_DS_MODAL = "primer-checkout-3ds-modal", o.VAULT = "primer-checkout-vault", o.VAULT_INLINE = "primer-checkout-vault-inline", o.NAVIGATE_PAYMENT_METHODS = "primer-checkout-navigate-to-payment-methods", o.DIVIDER = "primer-checkout-payment-method-divider", o.APM_BUTTONS = "primer-checkout-apm-button-container", o.CARDHOLDER_NAME = "primer-checkout-cardholder-name", o.CARDHOLDER_NAME_INPUT = "primer-checkout-card-cardholder-name-input", o.ACTIONS = "primer-checkout-actions", o.ACTIONS_MENU = "primer-checkout-actions-menu", o.SAVE_PAYMENT_METHOD_CHECKBOX = "primer-checkout-save-payment-method-input", o.SAVE_PAYMENT_METHOD_FIELD = "primer-checkout-save-payment-method-field", o.SAVED_PAYMENT_METHODS_EMPTY = "primer-checkout-saved-payment-methods-empty-text", o.CARD_FORM = "primer-checkout-card-form", o.DD_SWITCH = "primer-checkout-switch-dd-inputs", o.DD_IBAN_FIELD = "primer-checkout-dd-iban-field", o.DD_LOCAL_FIELD = "primer-checkout-dd-local-fields", o.DD_CUSTOMER_NAME_INPUT = "primer-checkout-dd-customer-name-input", o.DD_CUSTOMER_EMAIL_INPUT = "primer-checkout-dd-customer-email-input", o.DD_CUSTOMER_ADDRESS_LINE1 = "primer-checkout-dd-customer-address-input", o.DD_CUSTOMER_ADDRESS_LINE2 = "primer-checkout-dd-customer-address-line2-input", o.DD_CUSTOMER_ADDRESS_CITY = "primer-checkout-dd-customer-city-input", o.DD_CUSTOMER_ADDRESS_POSTAL_CODE = "primer-checkout-dd-customer-postal-code-input", o.DD_IBAN_INPUT = "primer-checkout-dd-iban-input", o.DD_ACCOUNT_NUMBER_INPUT = "primer-checkout-dd-account-number-input", o.DD_BANK_CODE_INPUT = "primer-checkout-dd-bank-code-input", o.DD_BRANCH_CODE_INPUT = "primer-checkout-dd-branch-code-input", o.DD_MANDATE_SMALL_PRINT = "primer-checkout-small-print", o.ERROR_MESSAGE = "primer-checkout-error-message", (E = {}).TOKEN = "PrimerCheckout__token", E.HIDDEN = "PrimerCheckout--hidden", E.FOCUSED = "PrimerCheckout--focused", E.SELECTED = "PrimerCheckout--selected", E.LOADING = "PrimerCheckout--loading", E.ERROR = "PrimerCheckout--error", E.CARD_TYPE = "PrimerCheckout__cardType", E.SAVED_PAYMENT_METHOD = "PrimerCheckout__savedPaymentMethod", E.SAVED_PAYMENT_METHOD_CONTAINER = "PrimerCheckout__savedPaymentMethodContainer", E.APM_BUTTON = "PrimerCheckout__apmButton", E.EDIT_BUTTON = "PrimerCheckout__editButton", E.MENU = "PrimerCheckout__dropDownMenu", E.MENU_ITEM = "PrimerCheckout__dropDownMenuItem", E.PAYMENT_METHOD_MENU_ITEM = "PrimerCheckout__paymentMethodDropDownMenuItem", E.DELETE_PAYMENT_METHOD_BUTTON = "PrimerCheckout__paymentMethodDropDownMenuItem__deleteButton", E.ENTER = "PrimerCheckout--enter", E.ENTERING = "PrimerCheckout--entering", E.ENTERED = "PrimerCheckout--entered", E.EXIT = "PrimerCheckout--exit", E.EXITING = "PrimerCheckout--exiting", E.EXITED = "PrimerCheckout--exited";
    var e2 = ((n = {}).CHECKOUT = "CHECKOUT", n.HEADLESS_CHECKOUT = "HEADLESS_CHECKOUT", n.MANAGE_PAYMENT_METHODS = "MANAGE_PAYMENT_METHODS", n),
      e6 = ((_ = {}).DEFAULT = "DEFAULT", _.PREFER_VAULT = "PREFER_VAULT", _);
    (i = {}).TOKENIZE_STARTED = "tokenize-started", i.TOKENIZE_ERROR = "tokenize-error", i.TOKENIZE_SUCCESS = "tokenize-success", i.TOKENIZE_DID_NOT_START = "tokenize-did-not-start";
    var e5 = ((a = {}).SUCCESS = "AUTH_SUCCESS", a.FAILED = "AUTH_FAILED", a.SKIPPED = "SKIPPED", a.CHALLENGE = "CHALLENGE", a);
    var e3 = {
        WORLDPAY_IDEAL: "WORLDPAY_IDEAL",
        AUTOMATED_CLEARING_HOUSE: "AUTOMATED_CLEARING_HOUSE",
        ADYEN_KLARNA: "ADYEN_KLARNA",
        ADYEN_BANCONTACT_CARD: "ADYEN_BANCONTACT_CARD",
        PAY_NL_KAARTDIRECT: "PAY_NL_KAARTDIRECT",
        ADYEN_EPS: "ADYEN_EPS",
        ADYEN_BANCONTACT_PAYCONIQ: "ADYEN_BANCONTACT_PAYCONIQ",
        OMISE_PROMPTPAY: "OMISE_PROMPTPAY",
        OMISE_TRUEMONEY: "OMISE_TRUEMONEY",
        ADYEN_MULTIBANCO: "ADYEN_MULTIBANCO",
        PACYPAY_WECHAT: "PACYPAY_WECHAT",
        PACYPAY_ALIPAY: "PACYPAY_ALIPAY",
        ADYEN_MBWAY: "ADYEN_MBWAY",
        XENDIT_DANA: "XENDIT_DANA",
        XENDIT_SHOPEEPAY: "XENDIT_SHOPEEPAY",
        ADYEN_PAYSHOP: "ADYEN_PAYSHOP",
        ADYEN_PAYTRAIL: "ADYEN_PAYTRAIL",
        CLEARPAY: "CLEARPAY",
        RAPYD_FAST: "RAPYD_FAST",
        RAPYD_PROMPTPAY: "RAPYD_PROMPTPAY",
        RAPYD_GCASH: "RAPYD_GCASH",
        RAPYD_POLI: "RAPYD_POLI",
        RAPYD_GRABPAY: "RAPYD_GRABPAY",
        PRIMER_PAYPAL: "PRIMER_PAYPAL",
        TWOC2P: "TWOC2P",
        NETS: "NETS",
        STRIPE_ACH: "STRIPE_ACH",
        STRIPE_GIROPAY: "STRIPE_GIROPAY",
        MOLLIE_GIROPAY: "MOLLIE_GIROPAY",
        MOLLIE_EPS: "MOLLIE_EPS",
        PAY_NL_EPS: "PAY_NL_EPS",
        PAY_NL_P24: "PAY_NL_P24",
        MOLLIE_P24: "MOLLIE_P24",
        MOLLIE_SOFORT: "MOLLIE_SOFORT",
        COINBASE: "COINBASE",
        OPENNODE: "OPENNODE",
        MOLLIE_GIFT_CARD: "MOLLIE_GIFTCARD",
        XFERS_PAYNOW: "XFERS_PAYNOW",
        CARD: "PAYMENT_CARD",
        APPLE_PAY: "APPLE_PAY",
        GOOGLE_PAY: "GOOGLE_PAY",
        PAYPAL: "PAYPAL_ORDER",
        PAYPAL_VAULTED: "PAYPAL_BILLING_AGREEMENT",
        GO_CARDLESS: "GOCARDLESS",
        PAY_NL_IDEAL: "PAY_NL_IDEAL",
        PAY_NL_SOFORT_BANKING: "PAY_NL_SOFORT_BANKING",
        PAY_NL_BANCONTACT: "PAY_NL_BANCONTACT",
        PAY_NL_PAYPAL: "PAY_NL_PAYPAL",
        PAY_NL_CREDIT_TRANSFER: "PAY_NL_CREDIT_TRANSFER",
        PAY_NL_DIRECT_DEBIT: "PAY_NL_DIRECT_DEBIT",
        PAY_NL_GIROPAY: "PAY_NL_GIROPAY",
        PAY_NL_PAYCONIQ: "PAY_NL_PAYCONIQ",
        HOOLAH: "HOOLAH",
        ADYEN_BLIK: "ADYEN_BLIK",
        ADYEN_VIPPS: "ADYEN_VIPPS",
        ADYEN_GIROPAY: "ADYEN_GIROPAY",
        ADYEN_SOFORT: "ADYEN_SOFORT",
        ADYEN_IDEAL: "ADYEN_IDEAL",
        ADYEN_TRUSTLY: "ADYEN_TRUSTLY",
        ADYEN_ALIPAY: "ADYEN_ALIPAY",
        ADYEN_TWINT: "ADYEN_TWINT",
        ADYEN_MOBILEPAY: "ADYEN_MOBILEPAY",
        MOLLIE_BANCONTACT: "MOLLIE_BANCONTACT",
        MOLLIE_IDEAL: "MOLLIE_IDEAL",
        BUCKAROO_GIROPAY: "BUCKAROO_GIROPAY",
        BUCKAROO_EPS: "BUCKAROO_EPS",
        BUCKAROO_SOFORT: "BUCKAROO_SOFORT",
        BUCKAROO_BANCONTACT: "BUCKAROO_BANCONTACT",
        BUCKAROO_IDEAL: "BUCKAROO_IDEAL",
        ATOME: "ATOME",
        KLARNA_CUSTOMER_TOKEN: "KLARNA_CUSTOMER_TOKEN"
      },
      e4 = {
        WORLDPAY_IDEAL: "WORLDPAY_IDEAL",
        STRIPE_ACH: "STRIPE_ACH",
        STRIPE_IDEAL: "STRIPE_IDEAL",
        ADYEN_KLARNA: "ADYEN_KLARNA",
        ADYEN_BANCONTACT_CARD: "ADYEN_BANCONTACT_CARD",
        PAY_NL_KAARTDIRECT: "PAY_NL_KAARTDIRECT",
        ADYEN_EPS: "ADYEN_EPS",
        ADYEN_BANCONTACT_PAYCONIQ: "ADYEN_BANCONTACT_PAYCONIQ",
        OMISE_PROMPTPAY: "OMISE_PROMPTPAY",
        OMISE_TRUEMONEY: "OMISE_TRUEMONEY",
        ADYEN_MULTIBANCO: "ADYEN_MULTIBANCO",
        PACYPAY_WECHAT: "PACYPAY_WECHAT",
        PACYPAY_ALIPAY: "PACYPAY_ALIPAY",
        ADYEN_MBWAY: "ADYEN_MBWAY",
        XENDIT_DANA: "XENDIT_DANA",
        XENDIT_SHOPEEPAY: "XENDIT_SHOPEEPAY",
        ADYEN_PAYSHOP: "ADYEN_PAYSHOP",
        ADYEN_PAYTRAIL: "ADYEN_PAYTRAIL",
        CLEARPAY: "CLEARPAY",
        RAPYD_FAST: "RAPYD_FAST",
        RAPYD_PROMPTPAY: "RAPYD_PROMPTPAY",
        RAPYD_GCASH: "RAPYD_GCASH",
        RAPYD_POLI: "RAPYD_POLI",
        RAPYD_GRABPAY: "RAPYD_GRABPAY",
        PRIMER_PAYPAL: "PRIMER_PAYPAL",
        TWOC2P: "TWOC2P",
        NETS: "NETS",
        STRIPE_GIROPAY: "STRIPE_GIROPAY",
        MOLLIE_GIROPAY: "MOLLIE_GIROPAY",
        MOLLIE_EPS: "MOLLIE_EPS",
        PAY_NL_EPS: "PAY_NL_EPS",
        PAY_NL_P24: "PAY_NL_P24",
        MOLLIE_P24: "MOLLIE_P24",
        MOLLIE_SOFORT: "MOLLIE_SOFORT",
        COINBASE: "COINBASE",
        OPENNODE: "OPENNODE",
        MOLLIE_GIFT_CARD: "MOLLIE_GIFTCARD",
        XFERS_PAYNOW: "XFERS_PAYNOW",
        PAYMENT_CARD: "PAYMENT_CARD",
        APPLE_PAY: "APPLE_PAY",
        GOOGLE_PAY: "GOOGLE_PAY",
        PAYPAL: "PAYPAL",
        GO_CARDLESS: "GOCARDLESS",
        KLARNA: "KLARNA",
        PAY_NL_IDEAL: "PAY_NL_IDEAL",
        PAY_NL_SOFORT_BANKING: "PAY_NL_SOFORT_BANKING",
        PAY_NL_BANCONTACT: "PAY_NL_BANCONTACT",
        PAY_NL_PAYPAL: "PAY_NL_PAYPAL",
        PAY_NL_CREDIT_TRANSFER: "PAY_NL_CREDIT_TRANSFER",
        PAY_NL_DIRECT_DEBIT: "PAY_NL_DIRECT_DEBIT",
        PAY_NL_GIROPAY: "PAY_NL_GIROPAY",
        PAY_NL_PAYCONIQ: "PAY_NL_PAYCONIQ",
        HOOLAH: "HOOLAH",
        ADYEN_BLIK: "ADYEN_BLIK",
        ADYEN_MOBILEPAY: "ADYEN_MOBILEPAY",
        ADYEN_VIPPS: "ADYEN_VIPPS",
        ADYEN_GIROPAY: "ADYEN_GIROPAY",
        ADYEN_SOFORT: "ADYEN_SOFORT",
        ADYEN_IDEAL: "ADYEN_IDEAL",
        ADYEN_TRUSTLY: "ADYEN_TRUSTLY",
        ADYEN_ALIPAY: "ADYEN_ALIPAY",
        ADYEN_TWINT: "ADYEN_TWINT",
        ADYEN_BANK_TRANSFER: "ADYEN_BANK_TRANSFER",
        MOLLIE_BANCONTACT: "MOLLIE_BANCONTACT",
        MOLLIE_IDEAL: "MOLLIE_IDEAL",
        BUCKAROO_GIROPAY: "BUCKAROO_GIROPAY",
        BUCKAROO_EPS: "BUCKAROO_EPS",
        BUCKAROO_SOFORT: "BUCKAROO_SOFORT",
        BUCKAROO_BANCONTACT: "BUCKAROO_BANCONTACT",
        BUCKAROO_IDEAL: "BUCKAROO_IDEAL",
        ATOME: "ATOME"
      },
      e8 = {
        SINGLE_USE: "SINGLE_USE",
        MULTI_USE: "MULTI_USE"
      };
    e3.PAYPAL_VAULTED, e4.PAYPAL, e3.KLARNA_CUSTOMER_TOKEN, e4.KLARNA, e3.AUTOMATED_CLEARING_HOUSE, e4.STRIPE_ACH, e3.CARD, e4.PAYMENT_CARD;
    var e9 = ((s = {}).INITIALIZATION_ERROR = "INITIALIZATION_ERROR", s.NO_PAYMENT_METHODS = "NO_PAYMENT_METHODS", s.PRIMER_TEARDOWN = "PRIMER_TEARDOWN", s.PRIMER_SERVER_ERROR = "PRIMER_SERVER_ERROR", s.THREE_DS_AUTH_FAILED = "THREE_DS_AUTH_FAILED", s.TOKENIZATION_ERROR = "TOKENIZATION_ERROR", s.DUPLICATE_PAYMENT_METHOD_ERROR = "DUPLICATE_PAYMENT_METHOD_ERROR", s.CARD_NUMBER_ERROR = "CARD_NUMBER_ERROR", s.PAYMENT_METHOD_NOT_SETUP = "PAYMENT_METHOD_NOT_SETUP", s.PAYMENT_METHOD_NOT_PROVIDED = "PAYMENT_METHOD_NOT_PROVIDED", s.PAYMENT_METHOD_NOT_COMPATIBLE = "PAYMENT_METHOD_NOT_COMPATIBLE", s.RESUME_ERROR = "RESUME_ERROR", s.VALIDATION_ERROR = "VALIDATION_ERROR", s.PAYMENT_FAILED = "PAYMENT_FAILED", s.PAYMENT_CREATION_ABORTED = "PAYMENT_CREATION_ABORTED", s.PAYMENT_CREATION_DISABLED = "PAYMENT_CREATION_DISABLED", s.CLIENT_SESSION_UPDATE_ERROR = "CLIENT_SESSION_UPDATE_ERROR", s.INVALID_ARGUMENT = "INVALID_ARGUMENT", s.VAULT_FETCH = "VAULT_FETCH", s.VAULT_DELETE = "VAULT_DELETE", s.HEADLESS_VAULT_MANAGER_VALIDATION = "HEADLESS_VAULT_MANAGER_VALIDATION", s.CARD_FORM_VALIDATION_UNEXPECTED_FIELD = "CARD_FORM_VALIDATION_UNEXPECTED_FIELD", s.MISSING_FIRST_NAME_OR_LAST_NAME = "MISSING_FIRST_NAME_OR_LAST_NAME", s.MISSING_EMAIL_ADDRESS = "MISSING_EMAIL_ADDRESS", s.INVALID_FLOW = "INVALID_FLOW", s);
    function e7(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    var re = /*#__PURE__*/function (_I) {
      _inherits(re, _I);
      var _super2 = _createSuper(re);
      function re(e, r) {
        var _r$diagnosticsId, _r$isFromDeveloper;
        var _this2;
        _classCallCheck(this, re);
        _this2 = _super2.call(this, r.message), e7(_assertThisInitialized(_this2), "code", void 0), e7(_assertThisInitialized(_this2), "diagnosticsId", void 0), e7(_assertThisInitialized(_this2), "data", void 0), e7(_assertThisInitialized(_this2), "isFromDeveloper", void 0), _this2.code = e, _this2.diagnosticsId = (_r$diagnosticsId = r.diagnosticsId) !== null && _r$diagnosticsId !== void 0 ? _r$diagnosticsId : null, _this2.data = r.data, _this2.isFromDeveloper = (_r$isFromDeveloper = r.isFromDeveloper) !== null && _r$isFromDeveloper !== void 0 ? _r$isFromDeveloper : !1, _this2.name = "PrimerClientError", Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_this2), re);
        return _this2;
      }
      _createClass(re, null, [{
        key: "fromErrorCode",
        value: function fromErrorCode(e, r) {
          return new re(e, r);
        }
      }]);
      return re;
    }(I);
    var rr = ((c = {}).PAYMENT_METHOD = "PAYMENT_METHOD", c.CHECK = "CHECK", c);
    var rt = function rt(e) {
      var r = e === null || e === void 0 ? void 0 : e.mandateData;
      return !!r && "fullMandateText" in r;
    };
    var rA = ((T = {}).CHANGE = "change", T.ERROR = "error", T.FOCUS = "focus", T.BLUR = "blur", T.CLICK = "click", T.CLOSE = "close", T.CONFIRMED_KLARNA_CATEGORY = "CONFIRMED_KLARNA_CATEGORY", T.CONFIRMED_KLARNA_CATEGORY_ERROR = "CONFIRMED_KLARNA_CATEGORY_ERROR", T.KLARNA_SESSION_UPDATE = "KLARNA_SESSION_UPDATE", T.KLARNA_SESSION_REFRESH_ERROR = "KLARNA_SESSION_REFRESH_ERROR", T),
      ro = ((N = {}).CARD = "CARD", N.NATIVE = "NATIVE", N.REDIRECT = "REDIRECT", N.KLARNA = "KLARNA", N.ACH = "ACH", N);
    var rE = {
      SDK_VERSION: "v2.54.0",
      createHeadless: eJ,
      showUniversalCheckout: eq,
      showVaultManager: e0,
      preloadPrimer: eZ
    };
    return O;
  }();
});